import React from "react";
import i18next from "i18next";
import { PopupButton } from "../../Elements/PopupButton";
import { WidgetInput } from "../Widget/WidgetInput";
import { useWmsContext } from "../../Contexts/WmsContext";

export const WmsInput = (): JSX.Element => {
    const { url, setUrl, onAddUrl, loading } = useWmsContext();

    return (
        <div className="wms-input">
            <WidgetInput
                classname="wms-service-url"
                placeholder={i18next.t("addWms.inputPlaceholder")}
                value={url}
                onChange={(e) => setUrl(e.target.value)}
            />
            <div className="add-wms-button">
                <PopupButton icon={!loading ? "icon-geolite-plus" : undefined} loading={loading} onClick={onAddUrl} />
            </div>
        </div>
    );
};
